// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__30Kr_","inner":"Footer_inner__11YMb","nextIcon":"Footer_nextIcon__3VDnM","innerLeft":"Footer_innerLeft__3_dbh"};